import React from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { safeParseZoneId, useUserState } from "store/user-store";
import { useGetSupportedTimezones } from "api/api-hooks/user-hooks";
import { logInfo } from "utils/logging-utils";
import "./UserProfileTzSelect.scss"
import { ZonedDateTime } from "@js-joda/core";
import { SelectItem } from "primereact/selectitem";

export default function UserProfileTzSelect() {
  const displayTimezone = useUserState((state) => state.getDisplayTimezone());
    const setDisplayTimezone = useUserState((state) => state.setDisplayTimezone);

    const tzSelectData = useGetSupportedTimezones()
    const timezoneSelections = toSelectItems(tzSelectData.data)

    logInfo("display tz ", displayTimezone);


    const onDisplayTzChange = (e: DropdownChangeEvent) => {
        logInfo("Setting display timezone to ", e.value);
        setDisplayTimezone(e.value);
    }

    if(!timezoneSelections) {
        return <div>Loading timezones...</div>
    }

    return <div>
      <Dropdown placeholder="Select Display Timezone"
        className="tz-select w-full"
        value={displayTimezone}
        options={timezoneSelections}
        filter
        filterMatchMode="contains"
        onChange={onDisplayTzChange}
        optionValue="value"
    />
    </div>
}

const toSelectItems = (values: Record<string, string> | undefined) =>{
  if(!values) return []

  return Object.keys(values).map(value => {
    const zone = safeParseZoneId(value)
    const item: SelectItem = {
      value: value,
      label: `${values[value]} (${ZonedDateTime.now(zone).offset()})`
    }
    return item
  })
}